import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { toast } from '@/hooks/use-toast';

interface NewsletterFormProps {
  language: string;
}

export const NewsletterForm = ({ language }: NewsletterFormProps) => {
  const [email, setEmail] = useState('');
  const [optIn, setOptIn] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !optIn) {
      toast({
        title: language === 'fr' ? 'Champs requis' : 'Required fields',
        description: language === 'fr'
          ? 'Veuillez renseigner votre email et accepter de recevoir nos actualités.'
          : 'Please enter your email and accept to receive our updates.',
        variant: 'destructive',
      });
      return;
    }

    setIsSubmitting(true);

    // Simulate submission
    setTimeout(() => {
      toast({
        title: language === 'fr' ? 'Inscription réussie !' : 'Successfully subscribed!',
        description: language === 'fr'
          ? 'Vous recevrez nos prochaines actualités par email.'
          : 'You will receive our next updates by email.',
      });
      setEmail('');
      setOptIn(false);
      setIsSubmitting(false);
    }, 500);
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-4">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            type="email"
            placeholder={language === 'fr' ? 'Votre adresse email' : 'Your email address'}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="pl-10"
            required
          />
        </div>
        <Button type="submit" disabled={isSubmitting} className="bg-primary hover:bg-primary/90">
          {language === 'fr' ? "S'inscrire" : 'Subscribe'}
        </Button>
      </div>
      <div className="flex items-start gap-2 text-left">
        <Checkbox
          id="newsletter-optin"
          checked={optIn}
          onCheckedChange={(checked) => setOptIn(checked === true)}
        />
        <label htmlFor="newsletter-optin" className="text-sm text-muted-foreground leading-tight cursor-pointer">
          {language === 'fr'
            ? "J'accepte de recevoir les actualités et publications de Gaius par email."
            : 'I agree to receive news and publications from Gaius by email.'}
        </label>
      </div>
    </form>
  );
};
